module.exports = __webpack_public_path__ + "static/media/bike1.bbb20a8a.jpg";